import { useParams } from "react-router-dom";
import { projects } from "../helpers/projectsList";

import React,{useEffect} from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

import BtnGitHub from "../components/btnGitHub/BtnGitHub";

export default function ProjectPage() {
  const { id } = useParams();
  const project = projects;

  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <main className="section">
      <div className="container" data-aos="flip-left" data-aos-duration="500">
        <div className="project-details">
          <h1 className="title-1">{project[id].title}</h1>

          <img
            src={project[id].imgBig}
            alt=""
            className="project-details__cover"
          />

          <div className="project-details__desc">
            <p>Skills: {project[id].skills}</p>
          </div>

          {project.gitHubLink && <BtnGitHub link="http://github.com" />}
        </div>
      </div>
    </main>
  );
}
